
import {
    ADRESS_GET_REQUEST,
    ADRESS_GET_SUCCESS,
    ADRESS_GET_FAIL,
    ADRESS_UPDATE_REQUEST,
    ADRESS_UPDATE_SUCCESS,
    ADRESS_UPDATE_FAIL
} from '../constants/adressConstants'
import { ACCOUNT_PUBLIC_INFO } from '../constants/accountConstants'

import { baseAxios } from '../jwtInterceptor'

export const get_adress = () => async(dispatch) => {
    baseAxios.defaults.headers.common["Authorization"] = `Bearer ${JSON.parse(localStorage.getItem('accountInfo')).access}`;
    dispatch({type:ADRESS_GET_REQUEST})
    await baseAxios.get('/api/account/adress/').
    then(
        (response) => {
            dispatch({type:ADRESS_GET_SUCCESS, payload:response['data']})
        }
    ).catch(
        (error) => {
            dispatch({
                type:ADRESS_GET_FAIL,
                payload:error.response && error.response.data.message
                ? 
                error.response.data.message
                :
                error.message
            })
        }
    )
}

export const update_adress = (country="japan", prefecture, region, address, building_name, postalcode, account={}) => async(dispatch, getState) => {
    dispatch({type:ADRESS_UPDATE_REQUEST})
    baseAxios.defaults.headers.common["Authorization"] = `Bearer ${JSON.parse(localStorage.getItem('accountInfo')).access}`;
    const data = {
        'country' : country,
        'prefecture': prefecture,
        'region': region,
        'address': address,
        'building_name': building_name,
        'postalcode': postalcode,
        ...account,
    }

    return await baseAxios.patch('/api/account/adress/', data).then(
        (response) => {
            const responseData = response['data']
            const {account: updatedAccount, ...addressData} = responseData
            dispatch({type:ADRESS_UPDATE_SUCCESS, payload: addressData})
            if(updatedAccount){
                const currentAccount = getState().accountPublicInfo.accountPublicInfo || {}
                const publicInfo = {...currentAccount, ...updatedAccount}
                dispatch({type:ACCOUNT_PUBLIC_INFO, payload: publicInfo})
                localStorage.setItem('publicAccountInfo', JSON.stringify(publicInfo))
            }
            return {success: true}
        }
    ).catch(
        (error) => {
            const responseData = error.response && error.response.data
            const phoneNumberError = responseData && responseData.phone_number
            const message = phoneNumberError
                ? 'この電話番号はすでに使用されています。登録済みの電話番号をご確認ください。'
                : error.response && error.response.status === 400
                ? '入力内容を登録できませんでした。電話番号が別のアカウントですでに使用されている可能性があります。入力内容をご確認ください。'
                : '登録に失敗しました。時間をおいて再度お試しください。'
            dispatch({
                type:ADRESS_UPDATE_FAIL, payload: message
            })
            return {success: false, message}
        }
    )
}
